import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginHeader from './components/LoginHeader';
import SocialLogin from './components/SocialLogin';
import LoginForm from './components/LoginForm';
import RegistrationPrompt from './components/RegistrationPrompt';
import SecurityIndicators from './components/SecurityIndicators';

const UserLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    if (isAuthenticated === 'true') {
      const userRole = localStorage.getItem('userRole');
      if (userRole === 'admin') {
        navigate('/admin-dashboard');
      } else {
        navigate('/user-dashboard');
      }
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-6xl grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
        {/* Left Column - Login Form */}
        <div className="flex flex-col justify-center">
          <div className="w-full max-w-md mx-auto">
            <LoginHeader />
            
            <div className="space-y-6">
              <SocialLogin />
              
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-border" />
                </div>
                <div className="relative flex justify-center text-xs uppercase">
                  <span className="bg-background px-2 text-muted-foreground">
                    Or sign in with email
                  </span>
                </div>
              </div>
              
              <LoginForm />
            </div>
            
            <SecurityIndicators />
          </div>
        </div>

        {/* Right Column - Registration Prompt & Benefits */}
        <div className="flex flex-col justify-center">
          <div className="w-full max-w-md mx-auto">
            <RegistrationPrompt />
            
            {/* Trust Signals */}
            <div className="mt-8 text-center">
              <p className="text-xs text-muted-foreground mb-4">
                Trusted by filmmakers worldwide
              </p>
              
              <div className="flex items-center justify-center space-x-8 opacity-60">
                <div className="text-xs font-medium text-muted-foreground">
                  10,000+ Credits Generated
                </div>
                <div className="w-px h-4 bg-border" />
                <div className="text-xs font-medium text-muted-foreground">
                  500+ Film Projects
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <div className="fixed bottom-0 left-0 right-0 bg-background/80 backdrop-blur-sm border-t border-border p-4">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between text-xs text-muted-foreground">
          <div className="flex items-center space-x-4 mb-2 sm:mb-0">
            <span>&copy; {new Date()?.getFullYear()} RealRoll. All rights reserved.</span>
          </div>
          <div className="flex items-center space-x-4">
            <button className="hover:text-foreground transition-micro">
              Privacy Policy
            </button>
            <button className="hover:text-foreground transition-micro">
              Terms of Service
            </button>
            <button className="hover:text-foreground transition-micro">
              Support
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserLogin;